// src/Pages/Home.js
import React from 'react';

const Admin = () => {
  return <div>Welcome to Home Page</div>;
};

export default Admin;
